import { Dispatch, SetStateAction } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import useTranslation from '@/hooks/useTranslation';

interface IModalProps {
  openDeletingModal: boolean;
  setOpenDeletingModal: Dispatch<SetStateAction<boolean>>;
  row_id: string;
  removeUserFromWorkspaceFunc: (user_id: string) => Promise<void>;
}

function RemoveFromWorkspaceModal({
  openDeletingModal,
  setOpenDeletingModal,
  row_id,
  removeUserFromWorkspaceFunc,
}: IModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={openDeletingModal}>
      <AlertDialogContent className="border-2 shadow-2xl border-dark-text/30">
        <AlertDialogHeader>
          <AlertDialogTitle>{lang.get('msg.areYouSure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {lang.get('msg.removeUserFromWorkspaceDescription')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-5">
          <AlertDialogCancel onClick={() => setOpenDeletingModal(false)}>
            {lang.get('msg.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              setOpenDeletingModal(false);
              removeUserFromWorkspaceFunc(row_id);
            }}
            className="bg-red-600 hover:bg-red-700"
          >
            {lang.get('msg.removeUser')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default RemoveFromWorkspaceModal;
